import React from 'react';
import { observer } from 'mobx-react';
import { Typography } from '@mui/material';
function LinearPileupDisplayBlurb(props) {
  var model = props.model;
  var sortedBy = model.sortedBy;
  return sortedBy ? React.createElement("div", {
    "data-testid": "blurb-".concat(model.sortedBy),
    style: {
      backgroundColor: 'white'
    }
  }, React.createElement(Typography, {
    color: "secondary",
    variant: "caption"
  }, model.sortedBy ? "Sorted by ".concat(sortedBy.type.toLowerCase(), " at ").concat(sortedBy.refName, ":").concat(sortedBy.pos) : null)) : null;
}
export default observer(LinearPileupDisplayBlurb);